import { UnreadVoicemailStatusFilter } from '~/types/ApiRequestTypes'

export enum VoicemailEmitterEventType {
  VOICEMAIL_DELETED = 'VOICEMAIL_DELETED',
  VOICEMAIL_MARKED_READ = 'VOICEMAIL_MARKED_READ',
  VOICEMAIL_MARKED_UNREAD = 'VOICEMAIL_MARKED_UNREAD',
  VOICEMAIL_FILTER_UPDATED = 'VOICEMAIL_FILTER_UPDATED',
  VOICEMAIL_INBOX_SELECTION_CHANGED = 'VOICEMAIL_INBOX_SELECTION_CHANGED',
}

export interface VoicemailDeletedPayload {
  voicemailId: number
}

export interface VoicemailMarkedAsReadPayload {
  voicemailId: number
}

export interface VoicemailFilterUpdatedPayload {
  filter: UnreadVoicemailStatusFilter
}

export interface VoicemailInboxSelectionChangedPayload {
  inboxId: number
}

export type VoicemailEmitterPayloadMap = {
  [VoicemailEmitterEventType.VOICEMAIL_DELETED]: VoicemailDeletedPayload
  [VoicemailEmitterEventType.VOICEMAIL_MARKED_READ]: VoicemailMarkedAsReadPayload
  [VoicemailEmitterEventType.VOICEMAIL_MARKED_UNREAD]: VoicemailMarkedAsReadPayload
  [VoicemailEmitterEventType.VOICEMAIL_FILTER_UPDATED]: VoicemailFilterUpdatedPayload
  [VoicemailEmitterEventType.VOICEMAIL_INBOX_SELECTION_CHANGED]: VoicemailInboxSelectionChangedPayload
}
